import FormAutoCompleteWithIcon from './FormAutoCompleteWithIcon';

export default FormAutoCompleteWithIcon;
